import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './ImageVideo.css';

export const extractVideoId = (url: string | null | undefined): string | null => {
    if (!url) return null;
    const videoIdRegex = /(?:youtube\.com\/(?:.*[?&]v=|[^/]+\/.*\/|v\/|e\/)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(videoIdRegex);
    return match ? match[1] : null;
};

interface ImageVideoChildProps {
    handleOpen: () => void;
    videoId: string | null;
}

interface ImageVideoProps {
    videoUrl: string | null | undefined;
    children: (props: ImageVideoChildProps) => React.ReactNode;
}

const ImageVideo: React.FC<ImageVideoProps> = ({ videoUrl, children }) => {
    const [open, setOpen] = useState(false);
    const videoId = extractVideoId(videoUrl);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {children({ handleOpen, videoId })}
            {videoId && (
                <Dialog
                    fullScreen
                    fullWidth
                    open={open}
                    onClose={handleClose}
                    className="image-video-dialog"
                >
                    <DialogContent className="image-video-dialog-content">
                        <IconButton
                            className="image-video-close-button"
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                        <iframe
                            className="image-video-iframe"
                            src={`https://www.youtube.com/embed/${videoId}?controls=1&autoplay=1&modestbranding=1&rel=0`}
                            allow="autoplay"
                            allowFullScreen
                            title="Video player"
                        />
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

export default ImageVideo;
